import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import { useChartLegendStyles } from './styles'

interface EnergyChartLegendProps {
  showDischargeIndicator: boolean
}

export const EnergyChartLegend: React.FC<EnergyChartLegendProps> = ({ showDischargeIndicator }) => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useChartLegendStyles()

  return (
    <Stack gap={3} className={classes.container}>
      <Stack direction="row" alignItems="center">
        <Box className={classes.squareIndicatorWrapper}>
          <Box className={cx(classes.squareIndicator, classes.gridIndicator)} />
        </Box>
        <Typography variant="body2" className={classes.indicatorLabel}>
          {t('emobility.chargingSession.grid-energy')}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center">
        <Box className={classes.squareIndicatorWrapper}>
          <Box className={cx(classes.squareIndicator, classes.solarIndicator)} />
        </Box>
        <Typography variant="body2" className={classes.indicatorLabel}>
          {t('emobility.chargingSession.solar-energy')}
        </Typography>
      </Stack>
      {showDischargeIndicator && (
        <Stack direction="row" alignItems="center">
          <Box className={classes.squareIndicatorWrapper}>
            <Box className={cx(classes.squareIndicator, classes.dischargeIndicator)} />
          </Box>
          <Typography variant="body2" className={classes.indicatorLabel}>
            {t('emobility.chargingSession.discharged-energy-legend')}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
